import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-utility-service',
  templateUrl : './template-utility-service.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplateUtilityService {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
